module.exports = __webpack_public_path__ + "img/homeScreen.3dc74bdb.png";